import { atob, applyVAT } from '../../utils/string';

const cartAnalytics = (lineItems, cachedItems, setup, currentCategory, value, remove = false, quantity = 1) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const itemCategory = currentCategory.split('/').reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
	const itemIds = lineItems.map((s) => ({ itemId: (s.merchandiseId.indexOf('/') === -1 ? atob(s.merchandiseId) : s.merchandiseId).replace('gid://shopify/ProductVariant/', ''), q: s.quantity }));

	if (remove) {
		window.dataLayer.push({
			event: 'remove_from_cart',
			ecommerce: {
				currency: setup.currency,
				value,
				items: itemIds.map(({ itemId, q = false }) => {
					const cachedProduct = cachedItems.filter((c) => c.sizes.filter((s) => s.id.indexOf(itemId) !== -1).length > 0).shift();
					if (!cachedProduct) return false;

					return {
						item_name: cachedProduct.name,
						item_id: `${itemId}`,
						price: applyVAT(setup, cachedProduct.price, false, 5),
						item_brand: cachedProduct.brand,
						...itemCategory,
						item_variant: cachedProduct.variant,
						quantity: `${q || quantity}`,
					};
				}).filter((a) => !!a),
			},
		});
		return;
	}
	window.dataLayer.push({
		event: 'AddToCart',
		values: {
			content_type: 'product',
			content_ids: itemIds,
		},
	});
	window.dataLayer.push({
		event: 'AddToCartGA',
		ecommerce: {
			currencyCode: setup.currency,
			add: {
				products: itemIds.map(({ itemId, q = false }) => {
					const cachedProduct = cachedItems.filter((c) => c.sizes.filter((s) => s.id.indexOf(itemId) !== -1).length > 0).shift();
					if (!cachedProduct) return false;
					const cachedItem = cachedProduct.sizes.filter((s) => s.id.indexOf(itemId) !== -1).shift();

					return {
						name: cachedProduct.name,
						id: cachedItem.sku,
						price: applyVAT(setup, cachedProduct.price, false, 5),
						brand: cachedProduct.brand,
						category: currentCategory,
						variant: cachedProduct.variant,
						quantity: `${q || quantity}`,
					};
				}).filter((a) => !!a),
			},
		},
	});
	window.dataLayer.push({
		event: 'add_to_cart',
		ecommerce: {
			currency: setup.currency,
			value,
			items: itemIds.map(({ itemId, q = false }) => {
				const cachedProduct = cachedItems.filter((c) => c.sizes.filter((s) => s.id.indexOf(itemId) !== -1).length > 0).shift();
				if (!cachedProduct) return false;

				return {
					item_name: cachedProduct.name,
					item_id: `${itemId}`,
					price: applyVAT(setup, cachedProduct.price, false, 5),
					item_brand: cachedProduct.brand,
					...itemCategory,
					item_variant: cachedProduct.variant,
					quantity: `${q || quantity}`,
				};
			}).filter((a) => !!a),
		},
	});
};

export default cartAnalytics;
